import React, { useEffect } from 'react'
import { useState } from 'react'
import { Box, Button } from '@mui/material'
import { grid, margin, Stack } from '@mui/system'
import Modal from '../../../common/modal'
import DropDownOA from '../../../common/dropDownOA'
import { Item } from '../../../common/snippets'
import { focusElemnt, navigation1 } from '../../../common/helper'
import * as sx from '../../../common/stylesInline/report_daily_branch'
import { cityListAtom, companySettingsAtom } from '../../../common/jotaiState/commonStateAtoms'
import useToken from '../../../helpers/useTokens'
import { useAtom } from 'jotai'
import { alertAtom, modalAtom } from '../../../common/jotaiState/globalStateAtoms'
import { getCrewTypeList } from './constants'
import LineinputV2 from '../../../common/lineinputV2'
import { getStatusOpt } from '../constants'
import { PostRequest } from '../../../common/api'
import { urls } from '../../../common/constants'
import { DatePicker } from '@mui/x-date-pickers'
import Datepicker from '../../../common/datePicker'
import moment from 'moment'
import { useTranslation } from '../../../../i18n/I18nProvider'
const modalStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
}
export const CreateUpdateCrew = (props) => {
    const { isEdit = false, crewData = {}, setCrewData = () => { }, } = props
    const { translations } = useTranslation()
    const bum = translations?.branchAndUserMaster || {}
    const cs = translations?.common || {}
    const crewTypeList = getCrewTypeList(translations)
    const statusOpt = getStatusOpt(translations)
    const { loginData } = useToken()
    const [cityList] = useAtom(cityListAtom)
    const [crewType, setCrewType] = useState(crewTypeList[0])
    const [status, setStatus] = useState(statusOpt[0])
    useEffect(() => {
        if (translations) {
            const currentCrewType = crewTypeList.find(item => item.id === crewType?.id);
            if (currentCrewType) setCrewType(currentCrewType);
            
            const currentStatus = statusOpt.find(item => item.id === status?.id);
            if (currentStatus) setStatus(currentStatus);
        }
    }, [translations]);
    const [city, setCity] = useState({})
    const [, setModal] = useAtom(modalAtom)
    const [, setAlert] = useAtom(alertAtom)

    useEffect(() => {
        focusElemnt("UMUserName")
    }, [])
    useEffect(() => {
        if (crewData?.DriverConductorID) {
            setCrewType(crewTypeList.find((item) => item.id == crewData?.CrewTypeID))
            setStatus(crewData?.IsActive ? statusOpt[0] : statusOpt[1])
            setCity(cityList.find((item) => item.CityID == crewData?.CityID))
        }
    }, [crewData])
    const velidation = () => {
        if (!crewData?.DriverConductorName) {
            setAlert({ show: true, msg: bum.fillUserName || "Fill User Name", nextId: "UMUserName" })
            return false
        } else if (!crewData?.ContactNo) {
            setAlert({ show: true, msg: bum.fillMobileNumber || "Fill Mobile Number", nextId: "UMMobileNo" })
            return false
        }else if(!crewData.CityID){
            setAlert({ show: true, msg: bum.selectCity || "Select City", nextId: "UMCity" })
            return false
        }
        else if (!crewData?.LicenseNo && [1, 2].includes(crewType?.id)) {
            setAlert({ show: true, msg: bum.licenseNoCanNotBeEmpty || "License No. Can Not Be Empty", nextId: "LicenseNo" })
            return false
        }
        return true
    }
    const saveApi = (edit) => {
        const data = {
            intCompanyID: loginData?.intCompanyID,
            intDriverConductorID: edit ? crewData?.DriverConductorID || 0 : 0,
            intBusID: 0,
            intIsDriver: 0,
            intStateID: 0,
            intCityID: crewData?.CityID || 0,
            intSelecteduser: 0,
            blnIsDriver: 0,
            blnIsActive: status?.id || 0,
            CrewTypeID: crewType?.id || 0,
            strDriverName: crewData?.DriverConductorName,
            strLicenseNo: crewData?.LicenseNo || "",
            strAddress: "",
            strContactNo: crewData?.ContactNo,
            strConductorCode: "",
            dtLicenseExpDate: crewData?.LicenseExpDate||"",
        }
        PostRequest(urls.driverConductorInsertUpdate, data).then((res) => {
            if (res.status === 'Success') {
                setAlert({ show: true, msg: isEdit ? (bum.crewUpdated || 'Crew Updated!!!') : (bum.crewCreated || 'Crew Created!!!'), nextId: '' })
                setModal(false)
                setCrewData({})
            } else {
                setAlert({ show: true, msg: res.ErrMessage, nextId: '' })
            }
        })
    }
    const onSave = () => {
        if (velidation()) {
            saveApi(isEdit)
        }
    }
    const requiredLabelTxt = (label) => (
        <span>
            {label}
            <span style={{ color: 'red', paddingLeft: '5px' }}>*</span>
        </span>
    )
    const handleBlur = (e) => {
        setCrewData({ ...crewData, [e.target.name]: e.target.value })
    }
    return (
        <>
            <Modal headTxt={isEdit ? (bum.editCrew || 'Edit Crew') : (bum.createNewCrew || 'Create New Crew')} modalStyle={modalStyle} modalClass={'booking-popup'} width={'50%'} closeId={"closeButton"} updateModal={setModal} sx={{ marginTop: '20px' }}>
                <Box style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr', gap: '16px', margin: '16px' }}>
                    <Item className="input--wrapper" sx={sx.itemsx}>
                        <LineinputV2
                            id={"DriverConductorName"}
                            label={requiredLabelTxt(bum.crewName || 'Crew Name')}
                            value={crewData?.DriverConductorName || ''}
                            type="text"
                            name="DriverConductorName"
                            sx={{ margin: '8px', width: '100%' }}
                            onBlur={handleBlur}
                            onKeyDown={(e) => navigation1(e, "DriverConductorID", "UMSave")}
                        />
                    </Item>
                    <Item className={'input--wrapper'} sx={sx.itemsx} >
                        <LineinputV2
                            id="DriverConductorID"
                            label={bum.crewId || 'Crew ID'}
                            value={crewData?.DriverConductorID || ''}
                            type="text"
                            name="DriverConductorID"
                            sx={{ margin: '8px', width: '100%' }}
                            disabled={true}
                            onKeyDown={(e) => navigation1(e, "CrewTypeID", "DriverConductorName")}
                        />
                    </Item>
                    <Item sx={sx.itemsx}>
                        <DropDownOA
                            id={"CrewTypeID"}
                            data={crewTypeList}
                            width="100%"
                            searchPlaceholder={bum.searchCrewType || `Search Crew Type`}
                            label={bum.selectCrewType || "Select Crew Type"}
                            defaultvalue={crewType?.name}
                            dataKey={`name`}
                            idKey={`id`}
                            nextId={"CityID"}
                            prevId={"DriverConductorID"}
                            onSelect={(value) => { setCrewType(value);setCrewData({...crewData,CrewTypeID:value?.id})}}
                        />
                    </Item>
                    <Item sx={sx.itemsx}>
                        <DropDownOA
                            id="CityID"
                            label={bum.selectCity || 'Select City'}
                            data={cityList}
                            defaultvalue={city?.CityName || ""}
                            width="100%"
                            searchPlaceholder={bum.searchDestinationCity || 'Search Destination City'}
                            typeOf={1}
                            isObjArr={true}
                            dataKey={`CityName`}
                            idKey={`CityID`}
                            nextId={"ContactNo"}
                            prevId={"CrewTypeID"}
                            onSelect={(val) => { setCrewData({ ...crewData, CityID: val.CityID }); setCity(val); }}
                        />
                    </Item>
                    <Item className={'input--wrapper'} sx={sx.itemsx}>
                        <LineinputV2
                            id={"ContactNo"}
                            label={requiredLabelTxt(bum.mobileNo || 'Mobile No')}
                            value={crewData?.ContactNo || ''}
                            type="text"
                            name="ContactNo"
                            sx={{ margin: '8px', width: '100%' }}
                            onBlur={handleBlur}
                            onKeyDown={(e) => navigation1(e, "LicenseNo", "CityID")}
                        />
                    </Item>
                    <Item className={'input--wrapper'} sx={sx.itemsx}>
                        <LineinputV2
                            id={"LicenseNo"}
                            label={bum.licenseNo || 'License No'}
                            value={crewData?.LicenseNo || ''}
                            type="text"
                            name="LicenseNo"
                            sx={{ margin: '8px', width: '100%' }}
                            onBlur={handleBlur}
                            onKeyDown={(e) => navigation1(e, "LicenseExpDate", "ContactNo")}
                            disabled={![1,2].includes(crewType?.id)}
                        />
                    </Item>
                    <Item sx={sx.itemsx} className="input--container bookingDatePicker">
                        <Datepicker
                            id={"LicenseExpDate"}
                            label={bum.licenseExpiryDate || 'License Expiry Date'}
                            width="100%"
                            date={crewData?.LicenseExpDate}
                            startDate={'01-Jan-2025'}
                            endDate={'01-Jan-2099'}
                            statusChecked={![1,2].includes(crewType?.id)}
                            dateChange={(date) => {
                                setCrewData({ ...crewData, LicenseExpDate: date ? date.format("DD-MMM-YYYY") : "" })
                                focusElemnt("UMUserStatus")
                            }}
                        />
                    </Item>
                    <Item sx={sx.itemsx}>
                        <DropDownOA
                            id={"UMUserStatus"}
                            defaultvalue={status?.name || ""}
                            data={statusOpt || []}
                            width="100%"
                            searchPlaceholder={bum.searchCrewStatus || `Search Crew Status`}
                            label={bum.crewStatus || "Crew Status"}
                            dataKey={`name`}
                            idKey={`id`}
                            nextId={"UMSave"}
                            prevId={"LicenseExpDate"}
                            isError={status?.id == 0}
                            isSuccess={status?.id == 1}
                            onSelect={(value) =>{ setStatus(value); setCrewData({...crewData,IsActive:!!value?.id})}}
                        />
                    </Item>
                    <Item className={'input--wrapper'} sx={sx.itemsx}></Item>
                    <Item className={'input--wrapper'} sx={sx.itemsx}></Item>
                    <Item className={'input--wrapper'} sx={sx.itemsx}></Item>
                    <Item sx={sx.itemsx} >
                    <Button variant="contained" id="UMSave" style={{ ...sx.fullHeight, ...sx.novp, padding: "5px 20px", width: '100%' }} className="btn btn-primary"
                        onClick={() => onSave()}
                    >
                        {isEdit ? (bum.update || cs.update || "Update") : (bum.create || "Create")}
                    </Button>
                </Item>
                </Box>
                
            </Modal>
        </>
    )
}
